import { Html, domUtils, useSignals } from "cayo.ui";
import React, { FC } from "react";
import { IWidget } from "../../api/schema.api";
import useRefreshKey from "../GlobalHooks/use-refresh-key.hook";
import GenericScheme from "../Schemes/GenericScheme";
import WidgetContainer from "./Container";
import WidgetHeader from "./Header";
import { EmptyContainer } from "./common";

const Widget: FC<IWidget & { data?: any; noDataMessage?: string; onRefresh?: () => void }> = (
  props
) => {
  const {
    name,
    title,
    titleSeparator,
    hideHeader,
    stick,
    noDataMessage,
    noLicenseMessage,
    onRefresh,
    showClock,
    help,
  } = props;
  const { key, forceRefresh, updateTime } = useRefreshKey(`widget_${name}`);

  const signals = useSignals<"refresh">([{ s: "refresh", handler: forceRefresh }]);

  return (
    // eslint-disable-next-line no-inline-styles/no-inline-styles
    <WidgetContainer key={key} stick={stick} style={{ alignContent: "stretch" }}>
      {title && !hideHeader && (
        <WidgetHeader
          title={title}
          titleSeparator={titleSeparator !== false}
          onRefresh={onRefresh ?? forceRefresh}
          showClock={!noLicenseMessage && showClock}
          updateTime={updateTime}
          help={help}
        />
      )}
      {noDataMessage && !noLicenseMessage && <EmptyContainer>{noDataMessage}</EmptyContainer>}
      {noLicenseMessage && (
        <EmptyContainer onMouseDown={domUtils.stopMouseDown}>
          <Html value={noLicenseMessage} />
        </EmptyContainer>
      )}
      {!noDataMessage && !noLicenseMessage && (
        <GenericScheme {...props} signals={signals} refreshKey={key} />
      )}
    </WidgetContainer>
  );
};

export default Widget;
